module.exports = __webpack_public_path__ + "static/media/ic_attachment.0024e6a1.svg";